export default "__VITE_ASSET__bdae908f__"